/**
 * nordura-video-showcase.js
 * <video-showcase> — mute/unmute + expand/collapse controls for the
 * CleanCold process video. Mute only applies to native (self-hosted)
 * <video> uploads; embedded YouTube/Vimeo iframes hide the sound button
 * since cross-origin audio control isn't reliably scriptable.
 */
(function () {
  'use strict';

  if (customElements.get('video-showcase')) return;

  class VideoShowcase extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video[data-n-native-video]');
      this.muteBtn = this.querySelector('[data-n-video-mute]');
      this.expandBtn = this.querySelector('[data-n-video-expand]');

      if (this.muteBtn) {
        if (!this.video) {
          this.muteBtn.remove();
        } else {
          this.muteBtn.addEventListener('click', this.toggleMute.bind(this));
        }
      }
      if (this.expandBtn) {
        this.expandBtn.addEventListener('click', this.toggleExpand.bind(this));
      }
    }

    toggleMute() {
      if (!this.video) return;
      this.video.muted = !this.video.muted;
      this.muteBtn.innerHTML = this.video.muted
        ? this.iconMarkup('mute')
        : this.iconMarkup('unmute');
    }

    toggleExpand() {
      var isBig = this.classList.toggle('is-big');
      this.expandBtn.innerHTML = isBig ? this.iconMarkup('collapse') : this.iconMarkup('expand');
    }

    iconMarkup(name) {
      var icons = {
        mute: '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H2v6h4l5 4V5z"></path><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line></svg>',
        unmute: '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5 6 9H2v6h4l5 4V5z"></path><path d="M15.5 8.5a5 5 0 0 1 0 7"></path><path d="M18.5 5.5a9 9 0 0 1 0 13"></path></svg>',
        expand: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 3H3v5M16 3h5v5M3 16v5h5M21 16v5h-5"></path></svg>',
        collapse: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 3v5H4M15 3v5h5M9 21v-5H4M15 21v-5h5"></path></svg>'
      };
      return icons[name] || '';
    }
  }

  customElements.define('video-showcase', VideoShowcase);
})();
